import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import {
  ThresholdIndicator,
  ThresholdIndicatorData,
} from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { isDynamic, isStatic } from '../../../core/types/type-guards.js';
import { WithId } from '../../../core/types/with-id.js';
import { transformThresholdIntoIndicator } from '../../../core/utils/thresholds-to-indicator.js';
import { useThresholdsState } from '../../hooks/store/selectors.js';
import { useThresholdConfig } from '../../hooks/useThresholdConfig.js';
import { useXScales } from '../../hooks/useXScale.js';
import { useYScales } from '../../hooks/useYScales.js';
import { TimeseriesChartThresholdConfig } from '../../types/timeseries-config.js';

export const ThresholdIndicators = () => {
  const { left, right } = useYScales();
  const { currentScale: xScale } = useXScales();
  const { left: leftThresholds, right: rightThresholds } = useThresholdConfig();
  const { width } = useGridPlotSize();
  const { hoveredThresholdId } = useThresholdsState();

  const thresholds: WithId<TimeseriesChartThresholdConfig>[] = [
    ...(leftThresholds ?? []),
    ...(rightThresholds ?? []),
  ];

  return (
    <>
      {thresholds.map(({ color, data, strokeOnly, position, id }, index) => {
        const yScale = position === 'left' ? left : right;

        if (!yScale) {
          return null;
        }

        const indicatorData: ThresholdIndicatorData[] =
          transformThresholdIntoIndicator(data, width, yScale.scale, xScale);
        const isStrokeOnly = isStatic(data) || isDynamic(data) || strokeOnly;

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${index}`}
            data={indicatorData}
            color={color}
            strokeOnly={isStrokeOnly}
            isActive={hoveredThresholdId === id}
          />
        );
      })}
    </>
  );
};
